<template>
  <v-app>
    <AppNav />
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppNav from '@/components/Nav'

export default {
  name: 'App',
  components: {
    AppNav,
  },
  mounted() {
    if ('Notification' in window) {
      this.$notification
        .requestPermission()
        .then(status =>
          console.log(
            `%cNotifications: ${status}`,
            `color: ${
              status == 'granted'
                ? '#4caf50'
                : status == 'denied'
                ? '#ff5252'
                : '#2196f3'
            }; font-weight: bold`
          )
        )
    }
  },
}
</script>

<style></style>
